"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.createStore('blockedDomainsOption', {
    blockedDomains: null,
})();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-blocked-domains-option/lib/store/store.js
// module id = 3062
// module chunks = 2